"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCancelOrderRequest = instanceOfCancelOrderRequest;
exports.CancelOrderRequestFromJSON = CancelOrderRequestFromJSON;
exports.CancelOrderRequestFromJSONTyped = CancelOrderRequestFromJSONTyped;
exports.CancelOrderRequestToJSON = CancelOrderRequestToJSON;
exports.CancelOrderRequestToJSONTyped = CancelOrderRequestToJSONTyped;
/**
 * Check if a given object implements the CancelOrderRequest interface.
 */
function instanceOfCancelOrderRequest(value) {
    return true;
}
function CancelOrderRequestFromJSON(json) {
    return CancelOrderRequestFromJSONTyped(json, false);
}
function CancelOrderRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderNo': json['orderNo'] == null ? undefined : json['orderNo'],
        'cancelReason': json['cancelReason'] == null ? undefined : json['cancelReason'],
    };
}
function CancelOrderRequestToJSON(json) {
    return CancelOrderRequestToJSONTyped(json, false);
}
function CancelOrderRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderNo': value['orderNo'],
        'cancelReason': value['cancelReason'],
    };
}
